import { useState, useEffect } from 'react'

export function useCountdown(
  initialHours: number,
  initialMinutes: number,
  initialSeconds: number,
) {
  const [timeLeft, setTimeLeft] = useState(() => {
    const totalSeconds =
      initialHours * 3600 + initialMinutes * 60 + initialSeconds
    return totalSeconds
  })

  useEffect(() => {
    if (timeLeft <= 0) return

    const intervalId = setInterval(() => {
      setTimeLeft((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [timeLeft])

  const days = Math.floor(timeLeft / (3600 * 24))
  const hours = Math.floor((timeLeft % (3600 * 24)) / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60

  return {
    days: days.toString().padStart(2, '0'),
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  }
}
